import styled from "styled-components"
import { GatsbyImage } from "gatsby-plugin-image"
import { Link } from "gatsby"
import { BaseCard } from "../base-card/base-card.styles"
// styling matching with course and workshop cards on individual author page
export const PostPreviewContainer = styled(BaseCard)`
  ${({ authorPage }) => authorPage && "grid-column: span 4"};
  border-radius: ${(props) => props.isResourceCard ? "5px" : ""};
  margin: 15px 0;
  display: flex;
  flex: auto;
  min-width: 270px;
  flex-direction: column;
  @media screen and (max-width: 1280px) {
    ${({ authorPage }) => authorPage && "grid-column: span 6"};
  }
  @media screen and (max-width: 768px) {
    margin: 10px 0;
  }
  @media screen and (max-width: 760px) {
    ${({ authorPage }) => authorPage && "grid-column: 1/-1"};
  }
`
PostPreviewContainer.displayName = "PostPreviewContainer"
/*ensure 16*9 image ratio below*/
export const PostPreviewImg = styled(GatsbyImage)`
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
  border-radius: 3px 3px 0 0;
  img {
    border-radius: 3px 3px 0 0;
  }
`
PostPreviewImg.displayName = "PostPreviewImg"

export const PostPreviewImgContainer = styled.div`
  position: relative;
`

PostPreviewImgContainer.displayName = "PostPreviewImgContainer"

export const PopularTextContainer = styled.div`
  background-color: ${({ theme: { colors } }) => colors.white};
  border-radius: 5px;
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 100;
  text-align: center;
  height: 30px;
  text-transform: uppercase;
  span {
    font-size: 12px;
    color: ${({ theme: { colors } }) => colors.accentBlue};
    font-weight: 600;
    padding: 10px;
    line-height: 30px;
    /*vertically align text with line-height equals to parent container height*/
  }
`
PopularTextContainer.displayName = "PopularTextContainer"

export const PostPreviewContentContainer = styled.div`
  ${(props) => props.authorPage && "flex-grow: 1"};
  padding: 25px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  @media screen and (max-width: 1049px) {
    height: ${({ theme, fixedHeight }) => (fixedHeight ? theme.ipad : "unset")};
  }
  @media screen and (width: 768px) and (orientation: portrait) {
    height: ${({ theme, fixedHeight }) =>
    fixedHeight
      ? theme.mobile
      : "unset"}; /*ipad fixed height for 2 col view*/
  }
  @media screen and (width: 1024px) and (orientation: landscape) {
    height: ${({ theme, fixedHeight }) =>
    fixedHeight ? theme.mobile : "unset"};
  }
  @media screen and (max-width: 767.5px) {
    height: unset; /*unset height for 1 column view*/
  }
`
PostPreviewContentContainer.displayName = "PostPreviewContentContainer"

export const ArticleAuthorCard = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`
ArticleAuthorCard.displayName = "ArticleAuthorCard"

export const ArticleAuthorImg = styled.img`
  width: 35px;
  height: 35px;
  border-radius: 50%;
  @media screen and (max-width: 768px) {
    width: 30px;
    height: 30px;
  }
`
ArticleAuthorImg.displayName = "ArticleAuthorImg"

export const ArticleAuthor = styled.span`
  ${({ theme: { typography } }) => typography.desktop.metadata}
  margin-left: 10px;
  @media screen and (max-width: 768px) {
    ${({ theme: { typography } }) => typography.mobile.metadata}
  }
`
ArticleAuthor.displayName = "ArticleAuthor"

export const ArticleTitle = styled(Link)`
  ${({ theme: { typography } }) => typography.desktop.h6}
  text-decoration: none;
  margin-top: 20px;
  cursor: pointer;
  @media screen and (max-width: 768px) {
    margin-top: 15px;
  }
`
ArticleTitle.displayName = "ArticleTitle"

export const ArticleEdition = styled(ArticleTitle)`
  margin-top: 8px;
  @media screen and (max-width: 768px) {
    margin-top: 8px;
  }
`
ArticleEdition.displayName = "ArticleEdition"

export const ArticleDesc = styled.p`
  ${({ theme: { typography } }) => typography.desktop.excerpt}
  margin: 20px 0 !important;
  flex: 1 1 auto;
  @media screen and (max-width: 768px) {
    ${({ theme: { typography } }) => typography.mobile.excerpt}
    line-height: 23px;
  }
`
ArticleDesc.displayName = "ArticleDescription"

export const ArticleMetaData = styled.div`
  margin-top: ${(props) => props.isResourceCard ? "-5px" : ""};
  margin-bottom: ${(props) => props.isResourceCard ? "15px" : ""};
  ${({ theme: { typography } }) => typography.desktop.metadata};
  display: flex;
  span {
    color: ${({ theme: { colors } }) => colors.accentBlue};
    margin: -2px 8px 0px;
    font-size: 28px;
  }
  @media screen and (max-width: 768px) {
    ${({ theme: { typography } }) => typography.mobile.metadata};
    margin-top: ${(props) => props.isResourceCard ? "-10px" : ""};
  margin-bottom: ${(props) => props.isResourceCard ? "15px" : ""};
  }
`
ArticleMetaData.displayName = "ArticleMetaData"
